import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

import { AuthService } from './services/auth/auth.service';
import { SessionService } from './services/session/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';
  history = [];

  @ViewChild('childModal') childModal: ModalDirective;

  constructor(
    private readonly idle: Idle,
    private readonly keepalive: Keepalive,
    private readonly router: Router,
    private readonly sessionService: SessionService,
    private readonly authService: AuthService,
    public translate: TranslateService
  ) {
    //Translation
    translate.addLangs(['fr']);
    translate.setDefaultLang('fr');

    // sets an idle timeout of 20 min before logging out
    idle.setIdle(1200);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.reset();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      this.timedOut = true;
      this.logout();
    });
    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.sessionService.getUserLoggedIn().subscribe((userLoggedIn) => {
      if (userLoggedIn) {
        idle.watch();
        this.timedOut = false;
      } else {
        idle.stop();
      }
    });
  }

  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  logout() {
    this.sessionService.setUserLoggedIn(false);
    this.authService.logout();
  }

  ngOnInit() {
    // initialisation du userLoggedIn à true
    this.sessionService.setUserLoggedIn(true);
  }
}
